<template>
  <div>
    <all-payments-table :value="filter === 'future' ? futureAllPayments : todaysAllPayments" />
    <div>
      <more-info :moreInfo="moreInfo.allPayments" @click="moreInfoOpen" />
    </div>
  </div>
</template>

<script>
import AllPaymentsMixin from '@/js/mixins/calculator/results/all-payments/all-payments-mixin';

export default {
  mixins: [AllPaymentsMixin],
};
</script>
